import { Box } from "@material-ui/core";
import { styled } from "@mui/material";

import { primary } from "../../../constants/theme";

const CustomTurnoMission = styled(Box)(({ theme }) => ({
  background: "#FEF8E6",
  padding: "132px 0px",
  ".heading": {
    fontSize: "46px",
    fontWeight: "700",
    lineHeight: "160%",
    maxWidth: "70%",
    width: "100%",
    margin: "auto",
    textAlign: "center",
  },
  ".mission-grid": {
    justifyContent: "center",
    marginTop: "24px",
    ".mission-point": {
      maxWidth: "300px",
      width: "90%",
      margin: "0px 10px",
      background: "#FFFFFF",
      padding: "20px 62px",
      textAlign: "center",
      boxShadow: "0px 2px 18px 2px #DEE9DC",
      borderRadius: "12px",
      ".mission-percent": {
        fontSize: "44px",
        fontWeight: "800",
        color: primary.main,
      },
      ".mission-description": {
        fontSize: "20px",
        fontWeight: "500",
        lineHeight: "160%",
        //textTransform: "capitalize",
      },
    },
  },
  [theme.breakpoints.down("md")]: {
    padding: "52px 0px",
    ".heading": {
      fontSize: "20px",
      lineHeight: "32px",
      maxWidth: "75%",
    },
    ".mission-grid": {
      justifyContent: "center",
      marginTop: "24px",
      ".mission-point": {
        maxWidth: "138px",
        margin: "10px",
        padding: "20px 14px",
        ".mission-percent": {
          fontSize: "18px",
          lineHeight: "30px",
        },
        ".mission-description": {
          fontSize: "12px",
          lineHeight: "16px",
        },
      },
    },
  },
}));

const TurnoMission = () => {};
export default TurnoMission;
